import { render, staticRenderFns } from "./AlcanceRenderer.vue?vue&type=template&id=0ca884d0"
import script from "./AlcanceRenderer.vue?vue&type=script&lang=js"
export * from "./AlcanceRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports